import { Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useEffect, useState } from 'react';
import { gql, useMutation } from '@apollo/client';
import ErrorPage from '../ErrorPage/ErrorPage';
import { getTranslations, isRtl } from '../../Helpers/language';
import errorTranslations from './errorTranslations';

export const SEND_LOG_MESSAGE = gql`
  mutation SendLogMessage($level: LogLevel!, $message: String!) {
    sendLogMessage(level: $level, message: $message) {
      logMessageSent
    }
  }
`;

const FormLoaderError = ({ supportId, message }) => {
  const messageWithSupportId = `Support ID: ${supportId}. ${message}`;
  const [translations, setTranslations] = useState();
  const [locale, setLocale] = useState('');

  const [sendLogMessage] = useMutation(SEND_LOG_MESSAGE);

  useEffect(() => {
    const browserLocale = navigator.language || navigator.userLanguage;
    setLocale(browserLocale);
    setTranslations(getTranslations(errorTranslations, browserLocale));
  }, []);

  useEffect(() => {
    if (supportId === undefined || message === undefined) {
      return;
    }

    sendLogMessage({
      variables: {
        level: 'ERROR',
        message: messageWithSupportId,
      },
    });
  }, [supportId, message]);

  if (!translations) {
    return null;
  }

  return (
    <ErrorPage
      Icon={ErrorOutlineIcon}
      title={translations.sorry_something_went_wrong}
      isRtl={isRtl(locale)}
    >
      <Typography>{translations.contact_site_admin} </Typography>
      <Typography>
        {translations.support_id}: {supportId}
      </Typography>
    </ErrorPage>
  );
};

export default FormLoaderError;
